import React from "react";

import { Grid } from "@material-ui/core";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import { MyCard } from "./MyCard";
import { InvitationForm } from "./InvitationForm";
import { InvitesTable } from "./InvitesTable";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
    },
  }),
);

export const InvitesPage = () => {
  const classes = useStyles();

  return (
    <div>
      <Grid container className={classes.root} spacing={2}>
        <Grid item xs={12}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12} md={8}>
              <MyCard title="Convites enviados" subTitle="">
                <InvitesTable />
              </MyCard>
            </Grid>
            <Grid item xs={12} md={4}>
              <InvitationForm />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
